export default class Feedback {
    flags: {
        feedbackOpened: boolean;
    } = {
        feedbackOpened: false,
    }

    classList: Record<string, string> = {
        hideFeedback: 'hide-feedback'
    }

    selectors: Record<string, string> = {
        feedbackSection: '#JS-feedback__right-section',
        feedbackButton: '#JS-feedback__button',
        feedbackBody: '#JS-feedback__body',
        feedbackCloseButton: '#JS-feedback__body--close-btn',
    }

    elements: {
        feedbackSection: HTMLElement | null,
        feedbackButton: HTMLElement | null,
        feedbackBody: HTMLElement | null,
        feedbackCloseButton: HTMLElement | null,
    } = {
        feedbackSection: null,
        feedbackButton: null,
        feedbackBody: null,
        feedbackCloseButton: null,
    }

    setElements() {
        this.elements.feedbackButton = this.elements.feedbackSection.querySelector(this.selectors.feedbackButton) as HTMLElement;
        this.elements.feedbackBody = this.elements.feedbackSection.querySelector(this.selectors.feedbackBody) as HTMLElement;
        this.elements.feedbackCloseButton = this.elements.feedbackSection.querySelector(this.selectors.feedbackCloseButton) as HTMLElement;
    }

    eventHandler = () => {
        this.elements.feedbackButton?.addEventListener('click', this.showFeedbackSection);
        this.elements.feedbackCloseButton?.addEventListener('click', this.hideFeedbackSection);
    }

    showFeedbackSection = () => {
        this.elements.feedbackBody.classList.remove(this.classList.hideFeedback);
    }

    hideFeedbackSection = () => {
        this.elements.feedbackBody.classList.add(this.classList.hideFeedback);
    }

    initialize() {
        const feedbackBlock = document.querySelector(this.selectors.feedbackSection) as HTMLElement;
        if (!feedbackBlock) return;
        this.elements.feedbackSection = feedbackBlock;
        this.setElements();
        this.eventHandler();
    }
}
